var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ErrorOutline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.084 13.7497H11.9173V15.583H10.084V13.7497ZM10.084 6.41634H11.9173V11.9163H10.084V6.41634ZM10.9915 1.83301C5.93148 1.83301 1.83398 5.93967 1.83398 10.9997C1.83398 16.0597 5.93148 20.1663 10.9915 20.1663C16.0607 20.1663 20.1673 16.0597 20.1673 10.9997C20.1673 5.93967 16.0607 1.83301 10.9915 1.83301ZM11.0007 18.333C6.94898 18.333 3.66732 15.0513 3.66732 10.9997C3.66732 6.94801 6.94898 3.66634 11.0007 3.66634C15.0523 3.66634 18.334 6.94801 18.334 10.9997C18.334 15.0513 15.0523 18.333 11.0007 18.333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/ErrorOutline.8eba1e7a15db787049b05204a584c882.svg";
export { ForwardRef as ReactComponent };